var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('button',{attrs:{"id":"delete-button"},on:{"click":function($event){return _vm.deleteComic()}}},[_vm._v("Delete From Collection")])])
}
var staticRenderFns = []

export { render, staticRenderFns }